import * as IconReactMd from "react-icons/fa";
import React from "react";
import {useTranslation} from "react-i18next";
import {formatDateHoursString} from "../../../utils/daysOptions";

export default function Evaluation() {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    function getValue(value: string | undefined | Date) {
        if (value instanceof Date) {
            return(formatDateHoursString(value))
        }
        return value
    }

    function getColorPerfil(perfil: string | undefined) {
        switch (perfil) {
            case 'normal':
                return 'text-gray-400'
            default:
                return 'text-green-600'
        }
    }

    function ResultEvaluation({evaluation, result, perfil, model}: {evaluation?: boolean, result?: string, perfil?: string, model: string}) {
        const classIcon = 'text-[50px]'

        return (
            <div className={'ml-auto w-full sm:w-auto custom-card p-2'}>
                <div className={`flex flex-row justify-center items-center text-white font-light text-[15px] 
                uppercase text-center border border-b-secondary border-transparent pb-2`}>
                    {`${t('model')}: ${getValue(model)}`}
                </div>
                <div className={'flex gap-3 justify-center items-center pt-2'}>
                    {evaluation ?
                        <IconReactMd.FaCheckCircle className={`${classIcon} text-success`}/> :
                        <IconReactMd.FaTimesCircle className={`${classIcon} text-red-600`}/>}
                    <span className={'text-[18px] text-white font-light'}>{result}</span>
                    <span className={`font-light text-[40px] ${getColorPerfil(perfil)}`}>{perfil}</span>
                </div>
            </div>
        )
    }
    return (<ResultEvaluation evaluation={true} result={'APROBADO'} perfil={'AA'} model={'EXAMPLE MODEL'}/>)
}
